import { Component} from '@angular/core';

@Component({
  selector: 'lib-error-outline-svg',
  templateUrl: './error-outline.component.svg'
})
export class ErrorOutlineSvgComponent { }

